import axios from 'axios';
import { Lodash, Common } from '@/utils';
import store from '../store';
import { Message } from 'iview';

axios.interceptors.request.use(config => {
    return config;
}, error => {
    throw new Error(error);
});

axios.interceptors.response.use(
    async response => {
        const { code, message } = response.data;
        const config = response.config;
        if (typeof code !== 'undefined' && config.method !== 'get' && code === 0 &&  config.showMsg) {
            Message.success({
                content: message || 'success',
                duration: 1.5
            })
        }
        if (typeof code !== 'undefined' &&  code !== 0) {
            Message.error({
                content: message || 'fail',
                duration: 3
            })
            if (code === 403) {
                await store.dispatch('common/LogOut');
            }
            return Promise.reject(response);
        } else {
            return response.data;
        }
    },
    error => {
        Message.error({
            content: error,
            duration: 3
        })
        return Promise.reject(error)
    }
);

export default (path, options = { method: 'GET' }, otherConfig = { showMsg: true }) => {
    const opt = Lodash.cloneDeep(options);
    opt.method = opt.method.toUpperCase();
    for (const key in opt.params) {
        if (!opt.params[key] && opt.params[key] != '0') delete opt.params[key];
    }
    const axiosConfig = {
        url: Common.replaceQuery(path, opt),
        method: opt.method,
        data: opt.params,
        baseURL: '/api',
        headers: options.headers || {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=UTF-8'
        },
        // 请求超时时间
        // timeout: 15000
        timeout: 120000
    };
    Object.keys(otherConfig).map(curr => {
        axiosConfig[curr] = otherConfig[curr];
    });
    return axios(axiosConfig);
};



// WEBPACK FOOTER //
// ./src/api/axios.js